import Button from 'components/_UI/Button';
import Fieldset from 'components/_UI/Fieldset';
import Text from 'components/_UI/Text';
import { useStepRegister } from 'context/login/StepRegister';
import { useUser } from 'context/user/User';
import masks from 'helpers/masks';
import React, { useState } from 'react';
import { Column } from 'styled/alignment/Column';
import { StyledForm } from 'styled/UI/StyledForm';
import colors from 'theme/colors';
import sizes from 'theme/sizes';
import { useForm } from 'react-hook-form';
import fieldValidations from 'helpers/fieldValidations';
import { HorizontalCenter } from 'styled/alignment/Center';
import unformat from 'helpers/unformat';
import userApi from 'api/requests/user';
import Loader from 'components/_UI/Loader';
import buttonText from 'texts/buttons/buttonText';
import step from 'helpers/system/step';

function RegisterStepTwo() {
    const { stepRegister, setStepRegister } = useStepRegister();
    const { user, setUser } = useUser();

    const [isLoading, setIsLoading] = useState(false);
    const [documentInvalid, setDocumentInvalid] = useState('');

    const [emailError, setEmailError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [documentError, setDocumentError] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            email: user.email || '',
            phone: user.phone || '',
            cpf: user.document || '',
        }
    });

    const nextStep = ({ email, phone, cpf }) => {
        const payload = {
            email,
            phone: unformat.getNumbers(phone),
            document: unformat.getNumbers(cpf)
        };
        setIsLoading(true);
        validateData(payload);
    };

    const validateData = async (payload) => {
        try {
            const { data } = await userApi.dataEnable(payload);
            const { email, phone, document } = data;
           
            if (email && phone && document) {
                setUser({...user, ...payload});
                setStepRegister(step.next(stepRegister));
            }
            
            setDocumentInvalid(false);
            setEmailError(!email);
            setPhoneError(!phone);
            setDocumentError(!document);
        } catch ({ response }) {
            setDocumentInvalid(response?.data?.errors?.document[0]);
            setEmailError(false);
            setPhoneError(false);
            setDocumentError(false);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Column fullyCentralized>
                <Text color={colors.neutral} type='bold' name='highlight'>
                    Agora precisamos de algumas
                </Text>
                <Text color={colors.neutral} type='bold' name='highlight'>
                    informações de contato
                </Text>
            </Column>

            <StyledForm
                marginTop={sizes.normal}
                paddingRight='13%'
                paddingLeft='13%'
                onSubmit={handleSubmit(nextStep)}
            >
                <Fieldset
                    placeholder='Email'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    name='email'
                    register={register}
                    validations={fieldValidations.email()}
                />

                {
                    (errors.email?.message || emailError) && (
                        <HorizontalCenter>
                            <Text color={colors.danger}> {errors.email?.message || 'E-mail já cadastrado'} </Text>
                        </HorizontalCenter>
                    )
                }

                <Fieldset
                    placeholder='Número de telefone'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    mask={masks.phone}
                    name='phone'
                    register={register}
                    validations={fieldValidations.phone()}
                />

                {
                    (errors.phone?.message || phoneError) && (
                        <HorizontalCenter>
                            <Text color={colors.danger}> {errors.phone?.message || 'Celular já cadastrado'} </Text>
                        </HorizontalCenter>
                    )
                }

                <Fieldset
                    placeholder='CPF'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    mask={masks.cpf}
                    name='cpf'
                    register={register}
                    validations={fieldValidations.cpf()}
                />
                {(errors.cpf?.message || documentError || documentInvalid) && (
                    <HorizontalCenter>
                        {(errors.cpf?.message || documentInvalid) && (
                            <Text color={colors.danger}>{errors.cpf?.message || documentInvalid}</Text>
                        )}
                        {documentError && (
                            <Text color={colors.danger}>CPF já cadastrado</Text>
                        )}
                    </HorizontalCenter>
                )}


                {!isLoading ? (
                    <Button
                        category='roundedBorded'
                        variant='secondary'
                        size='large'
                        marginTop={sizes.big}
                        type='submit'
                    >
                        {buttonText.next}
                    </Button>
                ) : <Loader />}

                <Button
                    category='minimal'
                    variant='primary'
                    size='large'
                    marginTop={sizes.nano}
                    onClick={() => setStepRegister(step.back(stepRegister))}
                >
                    {buttonText.back}
                </Button>
            </StyledForm>
        </>
    )
};

export default RegisterStepTwo;
